export default __webpack_public_path__ + "static/media/specialized-team.960100ad.png";